import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SavedCustomRoleManagementWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CustomRoleManagement/SavedCustomRoleManagementWrapper").then(
    (module) => ({
      default: module.SavedCustomRoleManagementWrapper,
    })
  )
);

export const savedPermissionSettingsRoleNRO: NavigationRoutingObject = {
  Component: SavedCustomRoleManagementWrapper,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("edit-role-nro-heading", "Edit Role"),
  pageNameForTracking: () => "Edit Role",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/roles/:appGroupId",
};
